import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {AuthProvider} from "./context/AuthProvider";
import {ProjectProvider} from './context/ProjectContext';
import {OrganizationProvider} from './context/OrganizationContext';
import {ThemeProvider} from './context/ThemeContext';
import {ToastProvider} from './components/ui/Toast';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <ThemeProvider>
        <ToastProvider>
            <AuthProvider>
                <OrganizationProvider>
                    <ProjectProvider>
                        <App/>
                    </ProjectProvider>
                </OrganizationProvider>
            </AuthProvider>
        </ToastProvider>
    </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
